import axios from '@/libs/api.request'

/**
 * 获取活动列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.limit 每页数量
 * @param {String} params.title 活动标题
 * @param {String} params.status 活动状态
 * @param {String} params.start_time 开始时间
 * @param {String} params.end_time 结束时间
 */
export const getActivityList = params => {
  return axios.request({
    url: '/v1/activity/list',
    method: 'get',
    params
  })
}

/**
 * 获取活动详情
 * @param {Number} id 活动ID
 */
export const getActivityDetail = id => {
  return axios.request({
    url: '/v1/activity/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 添加活动
 * @param {Object} data 活动数据
 * @param {String} data.title 活动标题
 * @param {String} data.content 活动内容
 * @param {String} data.cover_image 封面图片
 * @param {String} data.start_time 开始时间
 * @param {String} data.end_time 结束时间
 * @param {Number} data.status 状态（0：草稿，1：发布，2：结束）
 * @param {Object} data.extra 扩展字段
 */
export const addActivity = data => {
  return axios.request({
    url: '/v1/activity/add',
    method: 'post',
    data
  })
}

/**
 * 更新活动
 * @param {Object} data 活动数据
 * @param {Number} data.id 活动ID
 * @param {String} data.title 活动标题
 * @param {String} data.content 活动内容
 * @param {String} data.cover_image 封面图片
 * @param {String} data.start_time 开始时间
 * @param {String} data.end_time 结束时间
 * @param {Number} data.status 状态（0：草稿，1：发布，2：结束）
 * @param {Object} data.extra 扩展字段
 */
export const updateActivity = data => {
  return axios.request({
    url: '/v1/activity/update',
    method: 'put',
    data
  })
}

/**
 * 删除活动
 * @param {Number} id 活动ID
 */
export const deleteActivity = id => {
  return axios.request({
    url: '/v1/activity/delete',
    method: 'delete',
    params: { id }
  })
}

// ==================== 活动与企业关联管理 ====================

/**
 * 获取活动的企业列表
 * @param {Number} activityId 活动ID
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.limit 每页数量
 * @param {String} params.company_name 企业名称
 * @param {String} params.contacts 联系人
 * @param {String} params.phone 联系电话
 */
export const getActivityCompanyList = (activityId, params) => {
  return axios.request({
    url: '/v1/activity/company/list',
    method: 'get',
    params: { id: activityId, ...params }
  })
}

/**
 * 添加企业到活动
 * @param {Object} data 关联数据
 * @param {Number} data.activity_id 活动ID
 * @param {Number} data.company_id 企业ID
 * @param {String} data.contacts 联系人
 * @param {String} data.phone 联系电话
 * @param {String} data.remark 备注
 */
export const addActivityCompany = data => {
  return axios.request({
    url: '/v1/activity/company/add',
    method: 'post',
    data
  })
}

/**
 * 更新企业的活动信息
 * @param {Object} data 关联数据
 * @param {Number} data.id 关联ID
 * @param {Number} data.activity_id 活动ID
 * @param {Number} data.company_id 企业ID
 * @param {String} data.contacts 联系人
 * @param {String} data.phone 联系电话
 * @param {String} data.remark 备注
 */
export const updateActivityCompany = data => {
  return axios.request({
    url: '/v1/activity/company/update',
    method: 'put',
    data
  })
}

/**
 * 删除活动中的企业
 * @param {Number} id 关联ID
 */
export const deleteActivityCompany = id => {
  return axios.request({
    url: '/v1/activity/company/delete',
    method: 'delete',
    params: { id }
  })
}

// ==================== 企业招聘信息管理 ====================

/**
 * 获取企业在活动中的招聘信息列表
 * @param {Number} activityId 活动ID
 * @param {Number} companyId 企业ID
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.limit 每页数量
 * @param {String} params.job_name 职位名称
 * @param {Number} params.salary_min 最低工资
 * @param {Number} params.salary_max 最高工资
 */
export const getCompanyJobList = (activityId, companyId, params) => {
  return axios.request({
    url: '/v1/activity/company/job/list',
    method: 'get',
    params: { activity_id: activityId, company_id: companyId, ...params }
  })
}

/**
 * 添加企业在活动中的招聘信息
 * @param {Object} data 招聘信息
 * @param {Number} data.activity_id 活动ID
 * @param {Number} data.company_id 企业ID
 * @param {String} data.job_name 职位名称
 * @param {String} data.job_desc 职位描述
 * @param {Number} data.salary_min 最低工资
 * @param {Number} data.salary_max 最高工资
 * @param {String} data.education 学历要求
 * @param {String} data.experience 经验要求
 * @param {Number} data.recruitment_number 招聘人数
 */
export const addCompanyJob = data => {
  return axios.request({
    url: '/v1/activity/company/job/add',
    method: 'post',
    data
  })
}

/**
 * 更新企业在活动中的招聘信息
 * @param {Object} data 招聘信息
 * @param {Number} data.id 招聘信息ID
 * @param {Number} data.activity_id 活动ID
 * @param {Number} data.company_id 企业ID
 * @param {String} data.job_name 职位名称
 * @param {String} data.job_desc 职位描述
 * @param {Number} data.salary_min 最低工资
 * @param {Number} data.salary_max 最高工资
 * @param {String} data.education 学历要求
 * @param {String} data.experience 经验要求
 * @param {Number} data.recruitment_number 招聘人数
 */
export const updateCompanyJob = data => {
  return axios.request({
    url: '/v1/activity/company/job/update',
    method: 'put',
    data
  })
}

/**
 * 删除企业在活动中的招聘信息
 * @param {Number} id 招聘信息ID
 */
export const deleteCompanyJob = id => {
  return axios.request({
    url: '/v1/activity/company/job/delete',
    method: 'delete',
    params: { id }
  })
}

// ==================== 其他API ====================

/**
 * 获取企业列表（用于选择）
 * @param {Object} params 查询参数
 * @param {String} params.company_name 企业名称
 * @param {String} params.industry 行业
 * @param {String} params.address 地址
 */
export const getCompanySelectList = params => {
  return axios.request({
    url: '/v1/company/select/list',
    method: 'get',
    params
  })
}
